import { useQuery, QueryClient } from 'react-query';
import type { UseQueryResult } from 'react-query';
import { getAllowances, getTiers } from './api';
import type { AllowancesResponse, TiersResponse } from './api';
import type { Context } from '../types';

export const queryClient = new QueryClient();

const USE_GATES_QUERY_KEY = 'use-gates-query';
const USE_TIERS_QUERY_KEY = 'use-tiers-query';

export const QUERY_CONFIG = {
  staleTime: 60 * 60 * 1000,
  cacheTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
} as const;

export const useAllowancesQuery = (context: Context): UseQueryResult<AllowancesResponse> => {
  const enabled = context.id !== null;
  return useQuery({
    queryKey: [USE_GATES_QUERY_KEY, context.id, context.type],
    queryFn: () => {
      if (!enabled) {
        throw new Error();
      }
      return getAllowances(context);
    },
    enabled,
    ...QUERY_CONFIG,
  });
};

export function getAllowancesQuery(context: Context): Promise<AllowancesResponse> {
  const queryKey = [USE_GATES_QUERY_KEY, context.id, context.type];

  return queryClient.fetchQuery({
    queryKey,
    queryFn: () => {
      return getAllowances(context);
    },
    ...QUERY_CONFIG,
  });
}

export const useTierForGateQuery = (context: Context): UseQueryResult<TiersResponse> => {
  const enabled = context.id !== null;
  return useQuery({
    queryKey: [USE_TIERS_QUERY_KEY, context.id, context.type],
    queryFn: () => {
      if (!enabled) {
        throw new Error();
      }
      return getTiers(context);
    },
    enabled,
    ...QUERY_CONFIG,
  });
};

export function getTierForGateQuery(context: Context): Promise<TiersResponse> {
  const queryKey = [USE_TIERS_QUERY_KEY, context.id, context.type];

  return queryClient.fetchQuery({
    queryKey,
    queryFn: () => {
      return getTiers(context);
    },
    ...QUERY_CONFIG,
  });
}
